import { AbstractTemplateElementComponent } from './AbstractTemplateElementComponent';
import { tag } from '../../utils/tag';
import { BaitViewTypes } from '../../constants/BaitTypes';

export class LifesComponent extends AbstractTemplateElementComponent {
    #items = [];
    #rootEl;
    #value = 0;
    #num = 0;
    #viewType = BaitViewTypes.SWEETS_SCALP;

    constructor(num) {
        super();

        if (typeof num === 'number') {
            this.#value = -1;
            this.#num = num;
        }
    }

    _render(parentNode) {
        const rootEl = tag('span', 'lifes');

        const items = new Array(this.#num).fill('item').map((selector) => {
            const el = tag('span', `lifes__${selector}`);

            rootEl.appendChild(el);

            return el;
        });

        rootEl.setAttribute('role', 'img');
        rootEl.classList.add(`lifes--${this.#viewType}`);

        parentNode.appendChild(rootEl);

        this.#items = items;
        this.#rootEl = rootEl;

        this.value = this.#num;

        return [rootEl];
    }

    set value(value) {
        if (value === this.#value) return;

        this.#items.forEach((item, index) => {
            if (index < value) item.classList.add('active');
            else item.classList.remove('active');
        });

        this.#rootEl.setAttribute('alt', `Осталось жизней: ${value}`);

        this.#value = value;
    }

    get value() {
        return this.#value;
    }

    set viewType(value) {
        if (this.#viewType === value) return;
        if (!this.#rootEl) {
            this.#viewType = value;

            return;
        }

        this.#rootEl.classList.remove(`lifes--${this.#viewType}`);
        this.#rootEl.classList.add(`lifes--${value}`);

        this.#viewType = value;
    }

    get viewType() {
        return this.#viewType;
    }
}
